import { FAQS_SERVICE } from "@/services/faqs.service.js";

const state = {postFaqOutput: false, getFaqsOutput: {}, putFaqOutput: false, deleteFaqByIdOutput: false, getFaqByIdOutput: {}};

const actions = {
    //Service to create Faqs
    postFaq({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postFaqRequest');

        FAQS_SERVICE.postFaq(input)
            .then(
                output => {
                    commit('postFaqSuccess', output);
                },
                error => {
                    commit('postFaqFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated faqs
    getFaqs({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getFaqsRequest');

        FAQS_SERVICE.getFaqs(queryParams)
            .then(
                output => {
                    commit('getFaqsSuccess', output);
                },
                error => {
                    commit('getFaqsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update faqs
    putFaq({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putFaqRequest');

        FAQS_SERVICE.putFaq(input)
            .then(
                output => {
                    commit('putFaqSuccess', output);
                },
                error => {
                    commit('putFaqFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove faqs
    deleteFaqById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteFaqByIdRequest');

        FAQS_SERVICE.deleteFaqById(id)
            .then(
                output => {
                    commit('deleteFaqByIdSuccess', output);
                },
                error => {
                    commit('deleteFaqByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get faq details
    getFaqById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getFaqByIdRequest');

        FAQS_SERVICE.getFaqById(queryParams)
            .then(
                output => {
                    commit('getFaqByIdSuccess', output);
                },
                error => {
                    commit('getFaqByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postFaq
    postFaqRequest(state) {
        state.postFaqOutput = null;
    },
    postFaqSuccess(state, output) {
        state.postFaqOutput = true;
    },
    postFaqFailure(state) {
        state.postFaqOutput = false;
    },

    //getFaqs
    getFaqsRequest(state) {
    },
    getFaqsSuccess(state, output) {
        state.getFaqsOutput = output;
    },
    getFaqsFailure(state) {
        state.getFaqsOutput = false;
    },

    //putFaq
    putFaqRequest(state) {
        state.putFaqOutput = null;
    },
    putFaqSuccess(state, output) {
        state.putFaqOutput = true;
    },
    putFaqFailure(state) {
        state.putFaqOutput = false;
    },

    //deleteFaqById
    deleteFaqByIdRequest(state) {
        state.deleteFaqByIdOutput = null;
    },
    deleteFaqByIdSuccess(state, output) {
        state.deleteFaqByIdOutput = true;
    },
    deleteFaqByIdFailure(state) {
        state.deleteFaqByIdOutput = false;
    },

    //getFaqById
    getFaqByIdRequest(state) {
    },
    getFaqByIdSuccess(state, output) {
        state.getFaqByIdOutput = output;
    },
    getFaqByIdFailure(state) {
        state.getFaqByIdOutput = false;
    },
};

export const faqs = {
    namespaced: true,
    state,
    actions,
    mutations
};